import {  getRequestToken, postRequestToken,putRequestToken,deleteRequestToken, getRequestTokenCSV } from "../request/serverCall"



const getMenu=()=>{
    return getRequestToken("/security/menu").then(res=>{
        return res
    })
}

const countAlumnos=()=>{
    return getRequestToken("/stats/admin/count/alumnos").then(res=>{
        return res
    })
}

const countDocentes=(isPremium)=>{
    return getRequestToken("/stats/admin/count/docentes?premium=" + (isPremium ? "True" : "False")).then(res=>{
        return res
    })
}

const listAlumnos=(page,size)=>{
    return getRequestToken("/stats/admin/list/alumnos?page="+page+"&size="+size).then(res=>{
        return res
    })
}

const dashboardCombo=()=>{
    return getRequestToken("/stats/admin/combo/dashboard").then(res=>{
        return res
    })
}


const listDocentes=(page,size,roleId="")=>{
    return getRequestToken("/stats/admin/list/docentes/"+roleId+"?page="+page+"&size="+size).then(res=>{
        return res
    })
}


const listSponsors=(page,size)=>{
    return getRequestToken("/stats/admin/sponsors?page="+page+"&size="+size).then(res=>{
        return res
    })
}

const AddSponsors=(obj)=>{
    return postRequestToken("/sponsor",obj).then(res=>{
        return res
    })
}

const AsignarSponsors=(docente,sponsor)=>{
    return putRequestToken(`/usuarios/docentes/${docente}/${sponsor}`).then(res=>{
        return res
    })
}


const QuitarPremium=(docente,sponsor)=>{
    return deleteRequestToken(`/usuarios/docentes/${docente}/${sponsor}`).then(res=>{
        return res
    })
}
const GetAulasActivas=(docenteId,page,size)=>{
    return getRequestToken(`/stats/premium/${docenteId}/aulas?page=${page}&size=${size}`).then(res=>{
        return res
    })
}

const GetCinturonAlumno=(docenteId,alumnoId,page,size)=>{
    return getRequestToken(`/stats/premium/${docenteId}/alumnos/${alumnoId}/actividades/cinturonesAsteroidesCompletados?page=${page}&size=${size}`).then(res=>{
        return res
    })
}
const GetPasoNivelAlumno=(docenteId,alumnoId,page,size)=>{
    return getRequestToken(`/stats/premium/${docenteId}/alumnos/${alumnoId}/actividades/pasoDeNivel?page=${page}&size=${size}`).then(res=>{
        return res
    })
}

const GetPlanetasAlumno=(docenteId,alumnoId,page,size)=>{
    return getRequestToken(`/stats/premium/${docenteId}/alumnos/${alumnoId}/actividades/planetasDesbloqueados?page=${page}&size=${size}`).then(res=>{
        return res
    })
}

const GetHistoriasAlumno=(docenteId,alumnoId,page,size)=>{
    return getRequestToken(`/stats/premium/${docenteId}/alumnos/${alumnoId}/actividades/historiasLeidas?page=${page}&size=${size}`).then(res=>{
        return res
    })
}

const GetMiniJuegoAlumno=(docenteId,alumnoId,page,size)=>{
    return getRequestToken(`/stats/premium/${docenteId}/alumnos/${alumnoId}/actividades/minijuegosTerminados?page=${page}&size=${size}`).then(res=>{
        return res
    })
}

const GetAlumnosAulas=(docenteId,aula,page,size)=>{
    return getRequestToken(`/stats/premium/${docenteId}/aulas/${aula}/alumnos?page=${page}&size=${size}`).then(res=>{
        return res
    })
}

const getLogo=(id)=>{
    return getRequestToken(`/sponsor/${id}/logo`).then(res=>{
        return res
    })
}


const sharedCordon=(page,size)=>{
    return getRequestToken(`/stats/shared/cordonAsteroides?page=${page}&size=${size}`).then(res=>{
        return res
    })
}

const sharedPlanetas=(page,size)=>{
    return getRequestToken(`/stats/shared/planetas?page=${page}&size=${size}`).then(res=>{
        return res
    })
}


const sharedHistorias=(page,size)=>{
    return getRequestToken(`/stats/shared/historias?page=${page}&size=${size}`).then(res=>{
        return res
    })
}


const sharedMinijuegos=(page,size)=>{
    return getRequestToken(`/stats/shared/minijuegos?page=${page}&size=${size}`).then(res=>{
        return res
    })
}

const cinturonPromedioTotal=(docId)=>{
    return getRequestToken(`/stats/premium/${docId}/actividades/cinturonesAsteroidesCompletados/tiempoPromedio`).then(res=>{
        return res
    })
}

const HistoriasPromedioTotal=(docId)=>{
    return getRequestToken(`/stats/premium/${docId}/actividades/historiasLeidas/tiempoPromedio`).then(res=>{
        return res
    })
}
const miniJuegosTiempoPromedio=(docId)=>{
    return getRequestToken(`/stats/premium/${docId}/actividades/minijuegosTerminados/tiempoPromedio`).then(res=>{
        return res
    })
}

const CinturonVecesCompleto=(docId,idCordon)=>{
    return getRequestToken(`/stats/premium/${docId}/actividades/cinturonesAsteroidesCompletados/${idCordon}/tiempoPromedio`).then(res=>{
        return res
    })
}

const CinturonTiempo=(docId,idCordon)=>{
    return getRequestToken(`/stats/premium/${docId}/actividades/cinturonesAsteroidesCompletados/${idCordon}/tiempoPromedio`).then(res=>{
        return res
    })
}
const CinturonPasandoNivel=(docId,idCordon,isTrue)=>{
    return getRequestToken(`/stats/premium/${docId}/actividades/cinturonesAsteroidesCompletados/${idCordon}/vecesCompletado?pasandoDeNivel=${isTrue?"True":"False"}`).then(res=>{
        return res
    })
}

const CinturonTiempoADM=(idCordon)=>{
    return getRequestToken(`/stats/admin/actividades/cinturonesAsteroidesCompletados/${idCordon}/tiempoPromedio`).then(res=>{
        return res
    })
}
const CinturonPasandoNivelADM=(idCordon,isTrue)=>{
    return getRequestToken(`/stats/admin/actividades/cinturonesAsteroidesCompletados/${idCordon}/vecesCompletado?pasandoDeNivel=${isTrue?"True":"False"}`).then(res=>{
        return res
    })
}


const HistTiempo=(docId,idHist)=>{
    return getRequestToken(`/stats/premium/${docId}/actividades/historiasLeidas/${idHist}/tiempoPromedio`).then(res=>{
        return res
    })
}
const HistLeidas=(docId,idHist)=>{
    return getRequestToken(`/stats/premium/${docId}/actividades/historiasLeidas/${idHist}/cantidadLectura`).then(res=>{
        return res
    })
}

const HistTiempoADM=(idHist)=>{
    return getRequestToken(`/stats/admin/actividades/historiasLeidas/${idHist}/tiempoPromedio`).then(res=>{
        return res
    })
}
const HistLeidasADM=(idHist)=>{
    return getRequestToken(`/stats/admin/actividades/historiasLeidas/${idHist}/cantidadLectura`).then(res=>{
        return res
    })
}

const MiniJuegoTiempo=(docId,idMini)=>{
    return getRequestToken(`/stats/premium/${docId}/actividades/minijuegosTerminados/${idMini}/tiempoPromedio`).then(res=>{
        return res
    })
}
const MiniJuegoPasandoNivel=(docId,idMini,isTrue)=>{
    return getRequestToken(`/stats/premium/${docId}/actividades/minijuegosTerminados/${idMini}/vecesCompletado?abandonado=${isTrue?"True":"False"}`).then(res=>{
        return res
    })
}


const MiniJuegoTiempoADM=(idMini)=>{
    return getRequestToken(`/stats/admin/actividades/minijuegosTerminados/${idMini}/tiempoPromedio`).then(res=>{
        return res
    })
}
const MiniJuegoPasandoNivelADM=(idMini,isTrue)=>{
    return getRequestToken(`/stats/admin/actividades/minijuegosTerminados/${idMini}/vecesCompletado?abandonado=${isTrue?"True":"False"}`).then(res=>{
        return res
    })
}


const GetAlumnosAdmin=(page,size)=>{
    return getRequestToken(`/stats/admin/list/alumnos?page=${page}&size=${size}`).then(res=>{
        return res
    })
}

const CinturonAsteroideAdminAlumno=(aluId,page,size)=>{
    return getRequestToken(`/stats/admin/alumnos/${aluId}/actividades/cinturonesAsteroidesCompletados?page=${page}&size=${size}`).then(res=>{
        return res
    })
}

const PasoDeNivelAdminAlumno=(aluId,page,size)=>{
    return getRequestToken(`/stats/admin/alumnos/${aluId}/actividades/pasoDeNivel?page=${page}&size=${size}`).then(res=>{
        return res
    })
}

const planetasDesbloqueadosAdminAlumno=(aluId,page,size)=>{
    return getRequestToken(`/stats/admin/alumnos/${aluId}/actividades/planetasDesbloqueados?page=${page}&size=${size}`).then(res=>{
        return res
    })
}
const historiasLeidasAdminAlumnos=(aluId,page,size)=>{
    return getRequestToken(`/stats/admin/alumnos/${aluId}/actividades/historiasLeidas?page=${page}&size=${size}`).then(res=>{
        return res
    })
}
const MiniJuegosAdminAlumnos=(aluId,page,size)=>{
    return getRequestToken(`/stats/admin/alumnos/${aluId}/actividades/minijuegosTerminados?page=${page}&size=${size}`).then(res=>{
        return res
    })
}

const listFamiliasAdmin=(page,size)=>{
    return getRequestToken(`/stats/admin/familiares?page=${page}&size=${size}`).then(res=>{
        return res
    })
}
const listAlumnoByFamilia=(alumno,page,size)=>{
    return getRequestToken(`/stats/admin/familiares/${alumno}/alumnos?page=${page}&size=${size}`).then(res=>{
        return res
    })
}
const listInstitucionesAdmin=(page,size)=>{
    return getRequestToken(`/stats/admin/instituciones?page=${page}&size=${size}`).then(res=>{
        return res
    })
}

const listAlumnosByInstitucion=(insti,page,size)=>{
    return getRequestToken(`/stats/admin/instituciones/${insti}/alumnos?page=${page}&size=${size}`).then(res=>{
        return res
    })
}

const listDocenteByInstitucion=(insti,page,size)=>{
    return getRequestToken(`/stats/admin/instituciones/${insti}/docentes?page=${page}&size=${size}`).then(res=>{
        return res
    })
}

const listaLocalidades=(page,size)=>{
    return getRequestToken(`/stats/admin/localidades?page=${page}&size=${size}`).then(res=>{
        return res
    })
}

const listAlumnosByLocalidad=(localidadId,page,size)=>{
    return getRequestToken(`/stats/admin/localidades/${localidadId}/alumnos?page=${page}&size=${size}`).then(res=>{
        return res
    })
}

const listDocentesByLocalidad=(localidadId,page,size)=>{
    return getRequestToken(`/stats/admin/localidades/${localidadId}/docentes?page=${page}&size=${size}`).then(res=>{
        return res
    })
}

const listInstitucionesByLocalidad=(localidadId,page,size)=>{
    return getRequestToken(`/stats/admin/localidades/${localidadId}/instituciones?page=${page}&size=${size}`).then(res=>{
        return res
    })
}



const listaProvincias=(page,size)=>{
    return getRequestToken(`/stats/admin/provincias?page=${page}&size=${size}`).then(res=>{
        return res
    })
}

const listLocalidadesByProvincia=(ProvinciaId,page,size)=>{
    return getRequestToken(`/stats/admin/provincias/${ProvinciaId}/localidades?page=${page}&size=${size}`).then(res=>{
        return res
    })
}

const listAlumnosByProvincia=(ProvinciaId,page,size)=>{
    return getRequestToken(`/stats/admin/provincias/${ProvinciaId}/alumnos?page=${page}&size=${size}`).then(res=>{
        return res
    })
}

const listDocentesByProvincia=(ProvinciaId,page,size)=>{
    return getRequestToken(`/stats/admin/provincias/${ProvinciaId}/docentes?page=${page}&size=${size}`).then(res=>{
        return res
    })
}

const listInstitucionesByProvincia=(ProvinciaId,page,size)=>{
    return getRequestToken(`/stats/admin/provincias/${ProvinciaId}/instituciones?page=${page}&size=${size}`).then(res=>{
        return res
    })
}

const listaPais=(page,size)=>{
    return getRequestToken(`/stats/admin/paises?page=${page}&size=${size}`).then(res=>{
        return res
    })
}

const listProvinciasByPais=(PaisId,page,size)=>{
    return getRequestToken(`/stats/admin/paises/${PaisId}/provincias?page=${page}&size=${size}`).then(res=>{
        return res
    })
}

const listLocalidadesByPais=(PaisId,page,size)=>{
    return getRequestToken(`/stats/admin/paises/${PaisId}/localidades?page=${page}&size=${size}`).then(res=>{
        return res
    })
}

const listAlumnosByPais=(PaisId,page,size)=>{
    return getRequestToken(`/stats/admin/paises/${PaisId}/alumnos?page=${page}&size=${size}`).then(res=>{
        return res
    })
}

const listDocentesByPais=(PaisId,page,size)=>{
    return getRequestToken(`/stats/admin/paises/${PaisId}/docentes?page=${page}&size=${size}`).then(res=>{
        return res
    })
}

const listInstitucionesByPais=(PaisId,page,size)=>{
    return getRequestToken(`/stats/admin/paises/${PaisId}/instituciones?page=${page}&size=${size}`).then(res=>{
        return res
    })
}

const elementosCinturon=()=>{
    return getRequestToken(`/stats/admin/actividades/cinturonesAsteroidesCompletados/tiempoPromedio`).then(res=>{
        return res
    })
}

const elementosHistorias=()=>{
    return getRequestToken(`/stats/admin/actividades/historiasLeidas/tiempoPromedio`).then(res=>{
        return res
    })
}


const elementosMinijuego=()=>{
    return getRequestToken(`/stats/admin/actividades/minijuegosTerminados/tiempoPromedio`).then(res=>{
        return res
    })
}


const csvAlumnos=()=>{
    return getRequestTokenCSV(`/stats/admin/export/alumnos`).then(res=>{
        return res
    })
}

const csvDocentes=()=>{
    return getRequestTokenCSV(`/stats/admin/export/docentes`).then(res=>{
        return res
    })
}

const csvInstituciones=()=>{
    return getRequestTokenCSV(`/stats/admin/export/instituciones`).then(res=>{
        return res
    })
}

const csvFamiliares=()=>{
    return getRequestTokenCSV(`/stats/admin/export/familiares`).then(res=>{
        return res
    })
}

const csvAulas=()=>{
    return getRequestTokenCSV(`/stats/admin/export/aulas`).then(res=>{
        return res
    })
}

const csvAlumnosAulas=()=>{
    return getRequestTokenCSV(`/stats/admin/export/aulas/alumnos`).then(res=>{
        return res
    })
}

const csvDocentesInstituciones=()=>{
    return getRequestTokenCSV(`/stats/admin/export/instituciones/docentes`).then(res=>{
        return res
    })
}

const csvActividadesCordonesDeAsteroides=()=>{
    return getRequestTokenCSV(`/stats/admin/export/actividades/cordonesDeAsteroides`).then(res=>{
        return res
    })
}

const csvActividadesPasosDeNiveles=()=>{
    return getRequestTokenCSV(`/stats/admin/export/actividades/pasosDeNiveles`).then(res=>{
        return res
    })
}

const csvActividadesPlanetasDesbloqueados=()=>{
    return getRequestTokenCSV(`/stats/admin/export/actividades/planetasDesbloqueados`).then(res=>{
        return res
    })
}

const csvActividadesHistoriasLeidas=()=>{
    return getRequestTokenCSV(`/stats/admin/export/actividades/historiasLeidas`).then(res=>{
        return res
    })
}

const csvActividadesMinijuegosCompletados=()=>{
    return getRequestTokenCSV(`/stats/admin/export/actividades/minijuegosCompletados`).then(res=>{
        return res
    })
}

export default{
countAlumnos,countDocentes,csvAlumnos,csvInstituciones,csvFamiliares,csvDocentes,csvAulas,csvAlumnosAulas,csvDocentesInstituciones,csvActividadesCordonesDeAsteroides,csvActividadesPasosDeNiveles,csvActividadesPlanetasDesbloqueados,csvActividadesHistoriasLeidas,csvActividadesMinijuegosCompletados,MiniJuegoTiempoADM,MiniJuegoPasandoNivelADM,CinturonPasandoNivelADM,HistTiempoADM,HistLeidasADM,CinturonTiempoADM,elementosMinijuego,elementosHistorias,elementosCinturon,listaPais,listProvinciasByPais,listLocalidadesByPais, listInstitucionesByPais,listDocentesByPais,listAlumnosByPais,listLocalidadesByProvincia,listAlumnosByProvincia,listDocentesByProvincia,listInstitucionesByProvincia,listInstitucionesByLocalidad,listaProvincias,listDocentesByLocalidad,listDocenteByInstitucion,listAlumnosByLocalidad,listaLocalidades,listAlumnosByInstitucion,listInstitucionesAdmin,listAlumnoByFamilia,listFamiliasAdmin,historiasLeidasAdminAlumnos,MiniJuegosAdminAlumnos,PasoDeNivelAdminAlumno,planetasDesbloqueadosAdminAlumno,CinturonAsteroideAdminAlumno,GetAlumnosAdmin,MiniJuegoTiempo,MiniJuegoPasandoNivel,CinturonTiempo,HistLeidas,HistTiempo,CinturonPasandoNivel,CinturonVecesCompleto,miniJuegosTiempoPromedio,HistoriasPromedioTotal,cinturonPromedioTotal,sharedCordon,sharedHistorias,sharedMinijuegos,sharedPlanetas,getLogo,GetMiniJuegoAlumno,GetHistoriasAlumno,GetPlanetasAlumno,GetPasoNivelAlumno,listAlumnos,dashboardCombo,listDocentes,listSponsors,AddSponsors,AsignarSponsors,QuitarPremium,getMenu,GetAulasActivas,GetAlumnosAulas,GetCinturonAlumno
}


// WEBPACK FOOTER //
// src/API/privateCalls/privateActions.js